import { FilledButton, HouseHeader, TopAppBar } from 'components/Custom'
import { useLocation, useNavigate } from 'react-router-dom'
import { Rotas } from 'routes/rotas'
import { Box } from 'components/Material'
import { Grid, TextField } from '@mui/material'
import { useState } from 'react'
import { postContractToken } from 'services/simulacao/assinaturaContrato'
import { ErrorResponse, HandlerErrorMessage } from 'utils/HandlerErrorMessage'
import { useMutation } from '@tanstack/react-query'
import { useSnackbarAlertContext } from 'contexts/SnackbarContext'
import { AxiosError } from 'axios'

const ContractTokenValidation = () => {
  const navigate = useNavigate()
  const { showAlert } = useSnackbarAlertContext()

  // Inicializando 'code' como string vazia
  const [code, setCode] = useState<string>('')

  const location = useLocation()

  // Garantindo que 'encryptedConcc030' seja uma string ou número
  const encryptedConcc030 = location.pathname.split('/').pop() || ''

  const postContratoMutation = useMutation({ mutationFn: postContractToken })

  const handleSendContractToken = async () => {
    try {
      const response = await postContratoMutation.mutateAsync({
        codigo: code,
        id_concc030_cript: encryptedConcc030
      })

      // Limpa dados antigos do localStorage
      localStorage.clear() // Armazena os novos dados do contrato
      localStorage.setItem('sn_assinado', response.sn_assinado)
      localStorage.setItem('dh_assinatura', response.dh_assinatura)
      localStorage.setItem('pdf', response.report)
      localStorage.setItem('encrypted', encryptedConcc030)

      if (!response) {
        return showAlert({
          statusType: 'error',
          message: 'Erro ao tentar validar o código'
        })
      }

      navigate(Rotas.CONTRATO_VISUALIZACAO, {
        state: {
          code: code
        }
      })
    } catch (error) {
      const err = error as AxiosError<ErrorResponse>
      HandlerErrorMessage({
        showAlert,
        error: err,
        customErrorMessage: 'Informe um código de validação válido'
      })
    }
  }

  return (
    <Box className="w-full">
      <TopAppBar route="/solicitacao-contrato" leftText="Contrato" className="block" />
      <HouseHeader
        centerSmallWidth
        title="Código de"
        title2="Validação"
        subtitle="Informe o código enviado para seu acesso cadastrado:"
      />
      <Box className="p-5 flex justify-center">
        <Box className="w-full max-w-[350px] space-y-5">
          <Box className="py-5 space-y-5">
            <Grid
              container
              justifyContent="center"
              className="flex items-center w-full max-w-[350px]"
            >
              <Grid item container justifyContent="center">
                <Grid
                  item
                  justifyContent="center"
                  alignContent="center"
                  alignSelf="center"
                  className="w-full max-w-[350px] mt-5"
                >
                  <TextField
                    variant="outlined"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    label="Código"
                    className="w-full max-w-[350px] h-[56px]"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Box>

          <Box className="w-full flex justify-center items-center lg:items-end flex-col md:flex-row lg:justify-end gap-5 mb-5">
            <Box className="w-full max-w-[350px]">
              <FilledButton
                disabled={!code}
                onClick={handleSendContractToken}
                loading={postContratoMutation.isPending}
              >
                Visualizar contrato
              </FilledButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ContractTokenValidation
